import BaseEvent from './base_event';
import * as ItemsFactory from '../../objects/items/items_factory';
import FriendlyAlien from '../../objects/items/moveable/friendly_alien';
import BrownAlien from '../../objects/items/moveable/brown_alien';
import { Rarity } from '../../objects/items/base_item'

export default class Cryocapsule extends BaseEvent {

    static canOccur(gameState) {
        return !gameState.eventsResults.cryocapsule || (game.time.now - gameState.eventsResults.cryocapsule.last > 10000);    //todo: limit counts
    }

    enter(gameState) {
        gameState.eventsResults.cryocapsule = gameState.eventsResults.cryocapsule || { done: 0, last: 0 };
        gameState.eventsResults.cryocapsule.done++;
        gameState.eventsResults.cryocapsule.last = game.time.now;

        let room = gameState.getRandomRoomWithoutHero();

        this.ui.showDialog({
            message: `There’s a loud blip from the cockpit computer. Looks like you found a cryopod stranded in the middle of nowhere. Space code obliges you to help. Well, if you feel reasonably safe to do so. Unfortunately, space code was written with no regard to ice parasites and space pirate booby traps.`,
            options: [{
                text: `It’s a good thing I have a* scanner tool*. Let’s check the readings first and worry about x-ray overdose later.`,
                condition: gameState.has('cargo_scanner'),
                callback: () => {
                    gameState.history.push({ id: 'cryo', msg: 'overabused his cargo scanner'});
                    let dice_roll = game.rnd.frac();

                    if (dice_roll < 0.5) {
                        let item = ItemsFactory.produceByRarity(room, Rarity.RARE)[0];
                        gameState.items.add(item);

                        this.ui.showDialog({
                            message: `Scanner displays all green, and you open the cryocapsule to find the ${item.constructor.label} safely frozen inside. Who did this, and why? We’ll never know. (JK, gamedesigners did it).`,
                            status: "+" + item.constructor.label
                        }, this.end);
                    } else {
                        let item = ItemsFactory.produceMany(room, FriendlyAlien)[0];
                        gameState.items.add(item);

                        this.ui.showDialog({
                            message: `"Beep! Scan complete, no viruses found!"\nYou open the pod, and something jumps on your face! What a... what a cute little fella. Could you stop eating my shoe? Please?`, 
                            status: "Friendly alien"
                        }, this.end);
                    }
                }
            }, {
                text: `Scratch safety, someone might need my help! And I need a new freezer badly.`,
                callback: () => {
                    gameState.history.push({ id: 'cryo', msg: 'was kind and helpful to those stranded in a cold space'});
                    let dice_roll = game.rnd.frac();
                    if (dice_roll < 0.7) {
                        let item = ItemsFactory.produceMany(room, BrownAlien)[0];
                        gameState.items.add(item);
                        this.ui.showDialog({
                            message: `You open the pod, and something jumps on your face, trying to suck your brain out. Contrary to the popular notion, you do have one, so you quickly throw the bastard away and prepare your chair.`, // TODO: Tolik writes the best jokes
                            status: "Alien attack!"
                        }, this.end);
                    }  else {
                        let item = ItemsFactory.produceByRarity(room, Rarity.RARE)[0];
                        gameState.items.add(item);
                        this.ui.showDialog({
                            message: `You open the cryopod. Gah! There's a skeleton inside, clutching ${item.constructor.label} in his hands. Well, he doesn't need it anymore.`,
                            status: `+${item.constructor.label}`
                        }, this.end);
                    }
                }
            }, {
                text: `Nothing to see here. Move over.`,
                condition: gameState.energy > 0,
                callback: () => {
                    gameState.history.push({ id: 'cryo', msg: 'left a cryopo--REDACTED--'});
                    gameState.setEnergy(0);
                    gameState.badKarma = true;
                    this.ui.showDialog({
                        message: `You feel a slight prick of guilt while cleaning the ship log records. It’s a good thing this game would not punish you for a bad deed. It would not, would it?`,
                        status: "Negative karma"
                    }, this.end);
                }
            }]
        });
    }


}



// WEBPACK FOOTER //
// ./src/states/events/cryocapsule.js